import { formatCentsToDollars } from '@/shared/lib/format';

import { AppLocale } from './locale';

const INTL_LOCALES: Record<AppLocale, string> = {
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  pt: 'pt-BR',
  'pt-PT': 'pt-PT',
  ru: 'ru-RU',
};

export const getIntlLocale = (locale: AppLocale) => INTL_LOCALES[locale];

export const formatInterfaceNumber = (locale: AppLocale, value: number) =>
  new Intl.NumberFormat(getIntlLocale(locale)).format(value);

type CurrencyFormatOptions = {
  compact?: boolean;
};

export const formatInterfaceCurrency = (
  locale: AppLocale,
  amountInMinorUnits: number,
  currency = 'usd',
  options: CurrencyFormatOptions = {},
) => {
  const normalizedCurrency = currency?.trim().toUpperCase() || 'USD';

  // Pricing cards historically use whole-dollar labels and dot-separated thousands in English.
  // Keep that existing contract while allowing the other interfaces to retain standard currency precision.
  if (options.compact && locale === 'en' && normalizedCurrency === 'USD') {
    return `$${formatCentsToDollars(amountInMinorUnits)}`;
  }

  return new Intl.NumberFormat(getIntlLocale(locale), {
    currency: normalizedCurrency,
    ...(options.compact ? { maximumFractionDigits: 2, minimumFractionDigits: 0 } : {}),
    style: 'currency',
  }).format(amountInMinorUnits / 100);
};

export const formatInterfaceDate = (
  locale: AppLocale,
  date: Date | string,
  options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' },
) => new Intl.DateTimeFormat(getIntlLocale(locale), options).format(new Date(date));
